export default __webpack_public_path__ + "bc716f2ed9e1acd4ba5f1a9361ef02fa.png";